import React, { useCallback, useState } from 'react';
import { compose, defaultTo, groupBy, prop } from 'ramda';
import { branch, renderComponent, withProps } from 'recompose';
import { componentService } from 'js/services/component.service';
import { usePortletConfig, withPortlet } from 'js/components/system/Portlet';
import FadeInContainer from '../common/FadeInContainer';
import { statuses } from '../constants';
import { withEmptyState } from './../common/EmptyState';
import { LEADER_BOARD_RACES_LIST } from './constants';
import withTabs from './withTabs';
import Tabs from './Tabs';
import withMixedLeaderBoardList from './withMixedLeaderBoardList';
import withSortedList from './withSortedList';
import { recentlyEndedFirst } from '../helpers';
import Card from './RaceListCard';
import Skeleton from './Skeleton';
import style from './index.scss';

export const RacesListBare = ({ leaderboards, tabs, ...rest }) => {
    const [activeTab, setActiveTab] = useState(tabs[0].name);
    const onChangeTab = useCallback((name) => {
        setActiveTab(name);
    }, [setActiveTab]);

    return (
        <FadeInContainer className={style.container}>
            <div className={style.fixedContainer}>
                <Tabs tabs={tabs} activeTab={activeTab} onChange={onChangeTab} />
                <div className={style.raceList}>
                    {leaderboards[activeTab].map(board =>
                        <Card key={board.leaderboardId} {...board} {...rest} />)}
                </div>
            </div>
        </FadeInContainer>
    );
};

export const RacesList = compose(
    withPortlet({ forLoggedIn: true }),
    withProps(() => {
        const config = usePortletConfig();
        const {
            presentOnAirRaces,
            includePendingReview,
            maxEndedRacesQuantity,
            presentEndedRaces
        } = config;

        return {
            ...config,
            presentEndedRaces: presentEndedRaces && maxEndedRacesQuantity > 0,
            presentPendingRaces: presentOnAirRaces && includePendingReview
        };
    }),
    withMixedLeaderBoardList,
    branch(
        ({ leaderboards, error }) => !leaderboards && !error,
        renderComponent(Skeleton)
    ),
    withEmptyState,
    withSortedList,
    withProps(
        ({ leaderboards: lbs }) => {
            const leaderboards = groupBy(prop('status'), lbs);
            const { PENDING_REVIEW, ACTIVE, COMPLETED } = statuses;
            const { [PENDING_REVIEW]: pendingReview } = leaderboards;
            const { [COMPLETED]: completed } = leaderboards;

            if (pendingReview) {
                leaderboards[ACTIVE] = [
                    ...defaultTo([], leaderboards[ACTIVE]),
                    ...pendingReview
                ];
            }

            if (completed) {
                leaderboards[COMPLETED].sort(recentlyEndedFirst);
            }

            return {
                leaderboards
            };
        }
    ),
    withTabs
    )(RacesListBare);

    componentService.registerPageComponents({ [LEADER_BOARD_RACES_LIST]: RacesList });
